import { render, staticRenderFns } from "./complaint_suggestion_list.vue?vue&type=template&id=00e247e9&scoped=true"
import script from "./complaint_suggestion_list.vue?vue&type=script&lang=js"
export * from "./complaint_suggestion_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e247e9",
  null
  
)

export default component.exports